import {
  Button,
  Checkbox,
  Form,
  Input,
  Modal,
  Radio,
  Row,
  theme,
  Tooltip,
  Flex,
} from 'antd';
import { useContext, useState } from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import { NotificationInstance } from 'antd/es/notification/interface';
import { axiosInstance } from '../../utils/axios';
import {
  DashboardPageContentContext,
  removeP,
} from '../../context/DashboardContentProvider';
import '../../styles/dashboard.css';
import { InterpretationChoice } from '../../shared/enums/interpretation-choice.enum';

const { useToken } = theme;

export function SelectDuidingExpertModal({
  showModal,
  setShowModal,
  messageApi,
}: {
  showModal: boolean;
  setShowModal: (b: boolean) => void;
  messageApi: NotificationInstance;
}) {
  const [interpretation, setInterpretation] = useState(false);
  const [form] = Form.useForm();
  const [expertInterpretation, setExpertInterpretation] = useState(false);
  const { token } = useToken();

  const content = useContext(DashboardPageContentContext);

  interface FormItems {
    email: string;
    companyName: string;
  }

  const complete = (items?: FormItems) => {
    const interpretationChoice = interpretation
      ? InterpretationChoice.OWN_EXPERT
      : InterpretationChoice.NO_INTERPRETATION;

    axiosInstance
      .post('/company/interpretation-expert', {
        interpretationChoice,
        expertCompanyName: items?.companyName,
        expertCompanyEmail: items?.email,
      })
      .then(() => {
        setShowModal(false);
        messageApi.success({ message: 'Uw keuze is opgeslagen.' });
      })
      .catch(() => {
        messageApi.error({
          message: 'Er is iets misgegaan. Probeer het later opnieuw.',
        });
      });
  };

  return content === 'loading' ? (
    <></>
  ) : (
    <>
      <Modal
        title={removeP(content.home.title as string)}
        open={showModal}
        onCancel={() => setShowModal(false)}
        footer={[
          <Button key="cancel" onClick={() => setShowModal(false)}>
            Vul dit later in
          </Button>,
          <Button
            key="submit"
            onClick={() => {
              if (interpretation) form.submit();
              else complete();
            }}
          >
            Verstuur
          </Button>,
        ]}
      >
        {content.home.description}
        <Flex vertical gap={'middle'}>
          <Radio.Group
            onChange={(e) => setInterpretation(e.target.value)}
            value={interpretation}
          >
            <Radio value={true}>Ja</Radio>
            <Radio value={false}>Nee</Radio>
          </Radio.Group>
          {interpretation && (
            <Row>
              <Checkbox
                checked={expertInterpretation}
                onChange={(e) => setExpertInterpretation(e.target.checked)}
              >
                <Flex
                  style={{ width: '100%' }}
                  justify="space-between"
                  gap={'middle'}
                >
                  <div
                    style={{ flex: '70%', minWidth: 0 }}
                    className="no-margin"
                  >
                    {content.home.noExpert}
                  </div>
                  <div>
                    <Tooltip
                      title={<div>{content.home.noExpertInfo}</div>}
                      overlayStyle={{ maxWidth: '30em' }}
                      color={token.colorPrimary}
                    >
                      <InfoCircleOutlined style={{ marginLeft: '1%' }} />
                    </Tooltip>
                  </div>
                </Flex>
              </Checkbox>
              <Row>
                {content.home.expertContact}
                <Form
                  form={form}
                  name="expert"
                  disabled={expertInterpretation}
                  onFinish={complete}
                >
                  <Form.Item
                    label="Email"
                    name="email"
                    labelCol={{ span: 24 }}
                    rules={[
                      {
                        required: !expertInterpretation,
                        message: 'Vul alstublieft een email in.',
                      },
                      {
                        type: 'email',
                        message: 'Vul alstublieft een geldige email in.',
                      },
                    ]}
                  >
                    <Input placeholder="example@example.com" />
                  </Form.Item>
                  <Form.Item
                    label="Naam expert / bedrijf"
                    name="companyName"
                    labelCol={{ span: 24 }}
                    rules={[
                      {
                        required: !expertInterpretation,
                        message:
                          'Vul alstublieft de naam van het bedrijf of de expert in.',
                      },
                    ]}
                  >
                    <Input placeholder="Example bv." />
                  </Form.Item>
                </Form>
              </Row>
            </Row>
          )}
        </Flex>
      </Modal>
    </>
  );
}
